export default __webpack_public_path__ + "static/media/CV_Q-HJV.0fd3db79.pdf";